module.exports = __webpack_public_path__ + "e2d23b9db7f28ecd887123a23d7dff3e.svg";